import getFormattedRulesList from './formattedRules';
import getFormattedOutputs from './formattedOutputs';

export default { getFormattedRulesList, getFormattedOutputs };
